export enum QueryArrayFormat {
    Delimited = 'delimited', //?x=1,2
    RepeatedValue = 'repeated', //?x=1&x=2
    Brackets = 'brackets', // ?x[]=1&x[]=2
    Incrementing = 'incrementing', // ?x1=1&x2=2,
    JSON = 'json',
}
